module.exports = __webpack_public_path__ + "static/media/callefalsa123.8d49eb46.pdf";